import Routes from "./Routes";
import GlobalStyle from "./Style"

const App = () => {
  return (
    <>
      <GlobalStyle/>
      <Routes/>
    </>
  );
}

export default App;
